import * as React from "react";

import { IconHelp } from "@common/components/Atoms/Icons";

interface HelpButtonProps {
    small?: boolean
    onClick: () => void
}

export const HelpButton: React.SFC<HelpButtonProps> = (props) => {
    const height = (props.small && 19) || 24;
    const width = (props.small && 19) || 24;
    return (
        <button className="c-button--help" onClick={props.onClick}>
            <IconHelp width={width} height={height} />
        </button>
    );
};
